import { render, staticRenderFns } from "./SnackBarItem.vue?vue&type=template&id=5f1070b9&scoped=true&"
import script from "./SnackBarItem.vue?vue&type=script&lang=js&"
export * from "./SnackBarItem.vue?vue&type=script&lang=js&"
import style0 from "./SnackBarItem.vue?vue&type=style&index=0&id=5f1070b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1070b9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VIcon,VSnackbar})
